import { Check } from "lucide-react";

export function StepIndicator({ steps, step }) {
  return (
    <div className="flex items-center gap-2 mb-10">
      {steps.map((s, i) => (
        <div key={s} className="flex-1 flex items-center gap-2">
          <div className={`w-7 h-7 grid place-items-center text-[11px] font-mono border ${i <= step ? "bg-[#0A192F] text-white border-[#0A192F]" : "bg-white text-slate-500 border-slate-300"}`}>{i + 1}</div>
          <div className={`hidden md:block text-caption ${i === step ? "text-[#B91C1C]" : "text-slate-500"}`}>{s}</div>
          {i < steps.length - 1 && <div className="flex-1 h-px bg-slate-300" />}
        </div>
      ))}
    </div>
  );
}

export function DoneScreen() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center fade-in-up">
      <div className="w-16 h-16 border-2 border-[#15803D] rounded-full grid place-items-center mx-auto mb-6"><Check className="w-8 h-8 text-[#15803D]" /></div>
      <h1 className="text-3xl font-serif font-bold text-[#0A192F] mb-3">Referral received.</h1>
      <p className="text-slate-600 mb-8">Your secure intake has been logged. An RN will respond within 48 hours to confirm conflict clearance and engagement scope.</p>
      <a href="/" className="btn-navy inline-flex px-6 py-3 text-[12px] uppercase tracking-widest">Return Home</a>
    </div>
  );
}
